<template>
  <div>
    <div class="loading_content" v-if="show">
      <div class="loading">
        <lottie
          :options="defaultOptions"
          :height="120"
          :width="120"
          v-on:animCreated="handleAnimation"
        />
        <p>{{ $t('message.loading') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as animationData from './loading.json'
export default {
  name: 'loading',
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultOptions: { animationData: animationData },
      animationSpeed: 1,
      anim: {}
    }
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim
      // console.log(anim); //这里可以看到 lottie 对象的全部属性
    }
  }
}
</script>

<style lang="scss" scoped>
.loading_content {
  position: fixed;
  width: calc(100% - 267px);
  height: calc(100% - 70px);
  top: 70px;
  left: 267px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f6fe;
  z-index: 9999;
  .loading {
    box-sizing: border-box;
    width: 120px;
    text-align: center;
    /*background: rgba(0,0,0,0.3);*/
    color: rgba(255, 101, 0, 1);
    font-size: 16px;
  }
}
@media screen and (max-width: 850px) {
  .loading_content {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue